import { render, staticRenderFns } from "./Game_short_memory.vue?vue&type=template&id=f396a626&style=true"
import script from "./Game_short_memory.vue?vue&type=script&lang=js"
export * from "./Game_short_memory.vue?vue&type=script&lang=js"
import style0 from "./Game_short_memory.vue?vue&type=style&index=0&id=f396a626&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports